import _ from 'underscore';
import { FilterSchema, flattenEntitySchema } from '@bingads-webui/filter-schema';

const DEPRECATED_PROPERTIES = [
  'PhonePerformanceMetricsPhoneSpend',
  'PhonePerformanceMetricsClickCalls',
  'PhonePerformanceMetricsAverageCPP',
  'PhoneSpend',
  'ClickCalls',
  'AverageCPP',
];

const isExpressionDeprecated = () => expression => _.some(
  DEPRECATED_PROPERTIES,
  deprecatedColumn => _.has(expression, deprecatedColumn)
);

const applyConversionsToMongoPredicate = filterSchema =>
  mongoPredicate => filterSchema.applyConversions(mongoPredicate);

/**
 * When saving values into session, they got converted to string
 * This class is to deserialize the string value based on the value type
 * upon reading the value
 */
export class Deserializer {
  constructor(options = {
    parseIdAsInt: true,
  }) {
    const processedSchema = flattenEntitySchema(options.filterEntityOptions.entitySchema);
    this.filterSchema = new FilterSchema(processedSchema);
    this.parseIdAsInt = options.parseIdAsInt;
  }

  deserialize(filter) {
    const expressions = this.convert(filter.query ? filter.query : filter);

    let logicalOperator = null;

    if (filter.query) {
      if (filter.query.$or) {
        logicalOperator = '$or';
      } else if (filter.query.$and) {
        logicalOperator = '$and';
      }
    }

    return _.extend(filter, {
      query: this.parse(expressions, logicalOperator),
    });
  }

  convert(query) {
    if (!query) {
      throw new Error('query is not defined. Filter object is incorrect');
    }

    if (_.isEmpty(query)) {
      return [];
    }

    const mongoExpressions = (query.$and || query.$or) ?
      (query.$and || query.$or) : [query];
    return mongoExpressions;
  }

  parse(expressions, logicalOperator) {
    if (!_.isArray(expressions)) {
      throw new Error('First argument must be an array of legacy expressions');
    }
    if (_.isEmpty(expressions)) {
      return {};
    }

    const processedExpressions = _.chain(expressions)
      .filter(_.negate(isExpressionDeprecated()))
      .map(_.compose(
        applyConversionsToMongoPredicate(this.filterSchema),
        this.toMongoPredicate.bind(this, this.filterSchema)
      ))
      .value();

    if (processedExpressions.length === 1) {
      return processedExpressions[0];
    }
    return _.object(
      [logicalOperator || '$and'],
      [processedExpressions]
    );
  }

  toMongoPredicate(schema, expression) {
    const propName = _.pairs(expression)[0][0];
    const condition = _.pairs(expression)[0][1];
    const operator = _.pairs(condition)[0][0];
    let value = _.pairs(condition)[0][1];
    const props = schema.getFilterProperty(propName);
    if (props && props.type) {
      switch (props.type) {
        case 'datetime':
          value = new Date(value);
          break;
        case 'number':
          value = parseFloat(value);
          break;
        case 'integer':
          value = parseInt(value, 10);
          break;
        case 'boolean':
          value = Boolean(value);
          break;
        case 'id':
          if (this.parseIdAsInt) {
            value = _.map(value, item => parseInt(item, 10)); // labels have integer ids
          }
          break;
        // no default
      }
    }

    return _.object([propName], [_.object([operator], [value])]);
  }
}
